<template>
  <t-dialog
    :visible="visible"
    :header="$t('添加链接')"
    attach="#addLinkAttach"
    class="add-link-dialog"
    @close="handleClose"
  >
    <t-form ref="addLinkRef" :data="formData" label-align="top">
      <t-form-item :label="$t('链接文案')" name="linkText" :rules="requireRule">
        <t-input v-model="formData.linkText" :disabled="textDisable" />
      </t-form-item>
      <t-form-item :label="$t('链接地址')" name="linkUrl" :rules="urlRule">
        <t-input v-model="formData.linkUrl" />
      </t-form-item>
    </t-form>
    <template #footer>
      <t-button theme="primary" @click="handleSubmit">
        {{ $t("完成") }}
      </t-button>
      <t-button variant="outline" theme="default" @click="handleClose">
        {{ $t("取消") }}
      </t-button>
    </template>
  </t-dialog>
</template>

<script lang="ts" setup>
import { reactive, ref } from "vue";
import { FormInstanceFunctions } from "tdesign-vue-next";
import { t } from "@/utils/i18n";
import { trim } from "lodash-es";
import { validateUrl } from "@/utils/rules";

const emit = defineEmits(["submit"]);

const visible = ref(false);
const textDisable = ref(false);
const formData = reactive({
  linkText: "",
  linkUrl: "http://",
});

const addLinkRef = ref<FormInstanceFunctions | null>(null);

const requireRule = [
  {
    validator: (str) => {
      return !!trim(str);
    },
    message: t("不能为空"),
    trigger: "change",
  },
];

const urlRule = [
  {
    validator: (url) => {
      return !!trim(url);
    },
    message: t("不能为空"),
    trigger: "change",
  },
  {
    validator: (url) => {
      return validateUrl(url);
    },
    message: t("请输入正确url地址"),
    trigger: "change",
  },
];

const handleSubmit = async () => {
  if (addLinkRef.value) {
    const res = await addLinkRef.value.validate();
    if (res === true) {
      emit("submit", {
        linkText: formData.linkText.trim(),
        linkUrl: formData.linkUrl.trim(),
      });
      handleClose();
    }
  }
};

const handleClose = () => {
  visible.value = false;
};

const open = (text) => {
  formData.linkText = text;
  formData.linkUrl = "http://";
  textDisable.value = !!text;
  visible.value = true;
};

defineExpose({
  open,
  close: handleClose,
});
</script>

<style scoped>
.add-link-dialog {
  :deep(.flow-t-form__item) {
    margin-bottom: 12px;
  }
  :deep(.flow-t-form__item.flow-t-form__item-with-extra) {
    margin-bottom: 12px;
  }
}
</style>
